export enum Font {
  ROBOTO = 'Roboto',
  MONTSERRAT = 'Montserrat',
}

export const fontUrls: Record<Font, string> = {
  [Font.ROBOTO]:
    'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap',
  [Font.MONTSERRAT]:
    'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap',
};
